import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../utils/authContext';
import { useToast } from '../../components/Auth/Toast';
import { ToastContainer } from '../../components/Auth/Toast';
import Spinner from '../../components/Auth/Spinner';
import './AuthPages.css';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const { login, loading, error, setError } = useAuth();
  const { toasts, addToast, removeToast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    if (!formData.email) {
      addToast('Please enter your email', 'error');
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      addToast('Please enter a valid email', 'error');
      return false;
    }
    if (!formData.password) {
      addToast('Please enter your password', 'error');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!validateForm()) return;

    try {
      await login(formData);
      addToast('Login successful! Redirecting...', 'success');
      setTimeout(() => {
        navigate(location.state?.from?.pathname || '/');
      }, 1500);
    } catch (err) {
      addToast(error || 'Login failed', 'error');
    }
  };

  return (
    <div className='auth-container'>
      <ToastContainer toasts={toasts} removeToast={removeToast} />
      
      <div className='auth-page-wrapper'>
        {/* Logo Section */}
        <div className='auth-logo-section'>
          <div className='auth-logo-container'>
            <img
              src={require('../../assets/logo/logo1.jpeg')}
              alt='Laat Sahab News Logo'
              className='auth-logo-img'
            />
            <div className='auth-logo-text'>Laat Sahab News</div>
          </div>
        </div>

        {/* Form Section */}
        <div className='auth-form-wrapper'>
          <div className='auth-header'>
            <h1>🔐 Login</h1>
            <p>Welcome back to Laat Sahab News</p>
          </div>

          <form onSubmit={handleSubmit} className='auth-form'>
          <div className='form-group'>
            <label htmlFor='email'>Email Address</label>
            <input
              type='email'
              id='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
              placeholder='Enter your email'
              disabled={loading}
            />
          </div>

          <div className='form-group'>
            <label htmlFor='password'>Password</label>
            <div className='password-input-wrapper'>
              <input
                type={showPassword ? 'text' : 'password'}
                id='password'
                name='password'
                value={formData.password}
                onChange={handleChange}
                placeholder='Enter your password'
                disabled={loading}
              />
              <button
                type='button'
                className='password-toggle'
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <Link to='/forgot-password' className='forgot-password-link'>
            Forgot Password?
          </Link>

          <button
            type='submit'
            className='auth-button'
            disabled={loading}
          >
            {loading ? <Spinner size='sm' color='white' /> : 'Login'}
          </button>
        </form>

          <div className='auth-footer'>
            <p>
              Don't have an account?{' '}
              <Link to='/signup' className='auth-link'>
                Sign up here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
